
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.MaxOnDutyAlert = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'MaxOnDutyAlert'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'hoursOfServiceTypeContainer'
            }
          },
          {
            attributes: {
              class: 'control-group',
              id: 'minutesBeforeMaxOnDutyContainer'
            }
          }
        ]
      }]
    };
  },

  renderFields() {
    const hoursOfServiceType = new Monet.UI.Fields.Render({
      name: 'hoursOfServiceType',
      label: 'event.maxOnDutyAlert.hoursOfServiceType',
      mandatory: true,
      type: 'LOOKUP',
      lookupEntity: 'HoursOfServiceType',
      lookupEntityColumn: 'description'
    }, 'Event').render();

    const minutesBeforeMaxOnDuty = new Monet.UI.Fields.Render({
      name: 'minutesBeforeMaxOnDuty',
      label: 'event.maxOnDutyAlert.minutesBeforeMaxOnDuty',
      mandatory: true,
      type: 'INTEGER',
      defaultValue: '0',
    }).render();

    Greenmile.Checks.EventCheck.MaxOnDutyAlert.fields = { hoursOfServiceType, minutesBeforeMaxOnDuty };

    const hoursOfServiceTypeContainer = document.querySelector('#MaxOnDutyAlert #hoursOfServiceTypeContainer');
    hoursOfServiceTypeContainer.appendChild(hoursOfServiceType.rootEl);

    const minutesBeforeMaxOnDutyContainer = document.querySelector('#MaxOnDutyAlert #minutesBeforeMaxOnDutyContainer');
    minutesBeforeMaxOnDutyContainer.appendChild(minutesBeforeMaxOnDuty.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.MaxOnDutyAlert.renderFields();
    const fields = Greenmile.Checks.EventCheck.MaxOnDutyAlert.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.hoursOfServiceType.setValue(jsonParam.hoursOfServiceType);
      fields.minutesBeforeMaxOnDuty.setValue(jsonParam.minutesBeforeMaxOnDuty);
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.MaxOnDutyAlert.fields;
    return JSON.stringify({
      hoursOfServiceType: fields.hoursOfServiceType.getValue(),
      minutesBeforeMaxOnDuty: fields.minutesBeforeMaxOnDuty.getValue()
    });
  }
};
